import * as React from 'react';

export const LoadingSpinner: React.SFC = () => (
  <div className="loading-circle-parent">
    <div className="uil-default-css loading-circle">
      <div
        className="loading-tick"
        style={{ WebkitTransform: 'rotate(0deg) translate(0,-60px)', transform: 'rotate(0deg) translate(0,-60px)' }}
      />
      <div
        className="loading-tick"
        style={{
          WebkitTransform: 'rotate(30deg) translate(0,-60px)',
          transform: 'rotate(30deg) translate(0,-60px)'
        }}
      />
      <div
        className="loading-tick"
        style={{
          WebkitTransform: 'rotate(60deg) translate(0,-60px)',
          transform: 'rotate(60deg) translate(0,-60px)'
        }}
      />
      <div
        className="loading-tick"
        style={{
          WebkitTransform: 'rotate(90deg) translate(0,-60px)',
          transform: 'rotate(90deg) translate(0,-60px)'
        }}
      />
      <div
        className="loading-tick"
        style={{
          WebkitTransform: 'rotate(120deg) translate(0,-60px)',
          transform: 'rotate(120deg) translate(0,-60px)'
        }}
      />
      <div
        className="loading-tick"
        style={{
          WebkitTransform: 'rotate(150deg) translate(0,-60px)',
          transform: 'rotate(150deg) translate(0,-60px)'
        }}
      />
      <div
        className="loading-tick"
        style={{
          WebkitTransform: 'rotate(180deg) translate(0,-60px)',
          transform: 'rotate(180deg) translate(0,-60px)'
        }}
      />
      <div
        className="loading-tick"
        style={{
          WebkitTransform: 'rotate(210deg) translate(0,-60px)',
          transform: 'rotate(210deg) translate(0,-60px)'
        }}
      />
      <div
        className="loading-tick"
        style={{
          WebkitTransform: 'rotate(240deg) translate(0,-60px)',
          transform: 'rotate(240deg) translate(0,-60px)'
        }}
      />
      <div
        className="loading-tick"
        style={{
          WebkitTransform: 'rotate(270deg) translate(0,-60px)',
          transform: 'rotate(270deg) translate(0,-60px)'
        }}
      />
      <div
        className="loading-tick"
        style={{
          WebkitTransform: 'rotate(300deg) translate(0,-60px)',
          transform: 'rotate(300deg) translate(0,-60px)'
        }}
      />
      <div
        className="loading-tick"
        style={{
          WebkitTransform: 'rotate(330deg) translate(0,-60px)',
          transform: 'rotate(330deg) translate(0,-60px)'
        }}
      />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/common/loadingSpinner/LoadingSpinner.tsx